var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "appeal-point-sp-margin-top" }, [
    _c("p", { staticClass: "hd-type-04" }, [
      _c("span", [_vm._v("アピールポイント")]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "-right",
          style:
            "background: url(" +
            _vm.userOfferImageUrlForSp +
            "/icon_arrow_right_red.png) no-repeat left 1px; background-size: 8px 8px;",
          attrs: { target: "_blank", "data-test": "help" },
          on: {
            click: function ($event) {
              return _vm.openHelpPopUp("icon.html")
            },
          },
        },
        [_vm._v("\n      アイコンの説明\n    ")]
      ),
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "appeal-point" },
      _vm._l(_vm.prIconsMaster, function (prIcon) {
        return _c("li", {
          key: prIcon.id,
          class: { on: _vm.isSetPr(prIcon.id) },
          attrs: {
            id: _vm.targetIdMap.mainArticle.pr[prIcon.id],
            "data-test": "pr-" + prIcon.id,
          },
          domProps: { textContent: _vm._s(prIcon.name) },
        })
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }